// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","heading":"MutesPanel__heading--mX","headingIcon":"MutesPanel__headingIcon--fX","muteDetails":"MutesPanel__muteDetails--Gf"};